/**
 * Build CDN image URLs for admin previews.
 * Deployed admin: /images/{path} via same-origin CloudFront.
 * Local dev: REACT_APP_CDN_URL/{path}.
 */
export function getCdnImageUrl(relativePath: string): string {
  const path = relativePath.replace(/^\//, '');
  const isLocal =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const cdnUrl = process.env.REACT_APP_CDN_URL || 'https://cdn.stagespotter.com';

  if (isLocal) {
    return `${cdnUrl.replace(/\/$/, '')}/${path}`;
  }
  return `/images/${path}`;
}

/** Stored map_marker / venue_icon value → full image URL, or null if empty. */
export function mapMarkerImageUrl(storedValue: string | undefined | null): string | null {
  const trimmed = String(storedValue ?? '').trim();
  if (!trimmed) return null;
  return getCdnImageUrl(`map-markers/${trimmed}`);
}
